import MiteFormDictionary from '../../ru/mite-form/mite-form.dic.json';
import MiteRisksDictionary from '../../ru/mite-form/mite-risks.dic.json';

export const miteForm = {
  MITE_FORM: MiteFormDictionary,
  MITE_RISKS: MiteRisksDictionary,
};

export const miteFormNamespaces = ['MITE_FORM', 'MITE_RISKS'];
